import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { CreditCard, AlertTriangle, Copy, CheckCircle } from 'lucide-react'
import { useState } from 'react'

export function PaymentInstructionsSection() {
  const [copied, setCopied] = useState(false)
  const upiId = '9372951752m@pnb'

  const copyUPI = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    navigator.clipboard.writeText(upiId)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Card variant="premium">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <CreditCard className="w-5 h-5 text-primary" />
          </div>
          <div>
            <CardTitle>Payment Instructions</CardTitle>
            <p className="text-sm text-slate-500 mt-0.5">Scan QR or pay via UPI</p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-5">
          {/* QR Code */}
          <div className="flex flex-col items-center">
            <div className="max-w-[280px] w-full">
              <img
                src="/yuva_qr.jpg"
                alt="Payment QR Code"
                className="w-full rounded-xl border border-slate-200"
              />
            </div>
          </div>

          {/* UPI ID */}
          <div className="p-4 bg-slate-50 rounded-xl border border-slate-100">
            <p className="text-sm text-slate-600 mb-2">Or pay using UPI ID:</p>
            <div className="flex items-center gap-3">
              <code className="flex-1 px-4 py-3 bg-white rounded-lg border border-slate-200 text-lg font-mono font-semibold text-slate-900 tracking-wide">
                {upiId}
              </code>
              <button
                type="button"
                onClick={copyUPI}
                className="px-4 py-3 rounded-lg bg-primary text-white hover:bg-primary/90 transition-colors flex items-center gap-2"
              >
                {copied ? (
                  <>
                    <CheckCircle className="w-4 h-4" />
                    Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4" />
                    Copy
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Important Note */}
          <div className="p-4 bg-red-50 rounded-xl border border-red-200">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="w-4 h-4 text-red-600" />
              </div>
              <div>
                <h4 className="font-semibold text-red-900 text-sm mb-1">Important Note</h4>
                <p className="text-sm text-red-800/80">
                  Please mention your name in the payment description. Your payment screenshot <strong>must clearly show the Transaction ID</strong> for us to validate your payment. Invalid or fake screenshots will result in blacklisting from this and future events.
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
